import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { seedApi } from "./lib/api";

// Layout
import Layout from "./components/layout/Layout";

// Public Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ProjectsPage from "./pages/ProjectsPage";
import ProcessPage from "./pages/ProcessPage";
import ContactPage from "./pages/ContactPage";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminProjects from "./pages/admin/AdminProjects";

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}

// Seed data component
function SeedData() {
  useEffect(() => {
    const seedData = async () => {
      try {
        await seedApi.seedAdmin();
        await seedApi.seedProjects();
      } catch (error) {
        // Ignore errors - data already seeded
      }
    };
    seedData();
  }, []);

  return null;
}

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <SeedData />
        <Routes>
          {/* Public Routes */}
          <Route
            path="/"
            element={
              <Layout>
                <HomePage />
              </Layout>
            }
          />
          <Route
            path="/hakkimizda"
            element={
              <Layout>
                <AboutPage />
              </Layout>
            }
          />
          <Route
            path="/hizmetler"
            element={
              <Layout>
                <ServicesPage />
              </Layout>
            }
          />
          <Route
            path="/projeler"
            element={
              <Layout>
                <ProjectsPage />
              </Layout>
            }
          />
          <Route
            path="/surec"
            element={
              <Layout>
                <ProcessPage />
              </Layout>
            }
          />
          <Route
            path="/iletisim"
            element={
              <Layout>
                <ContactPage />
              </Layout>
            }
          />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminContacts />} />
            <Route path="projects" element={<AdminProjects />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
      <Toaster position="top-center" />
    </HelmetProvider>
  );
}

export default App;
